export default "__VITE_ASSET__4FDZjhXX__"